module.exports = __webpack_public_path__ + "img/research_llm.8d97c4ef.svg";